import React from 'react';
import { Button, Grid, Card, CardContent } from '@material-ui/core';
import '../assets/styles/contacts.css';

function ContactGrid({ searchTerm, contacts, removeContact, onEditContact }) {
  const filteredContacts = contacts.filter(
    (contact) =>
      contact.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      contact.lastName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Grid container spacing={3} className="contacts-grid">
      {filteredContacts.map((contact, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card className="contact-card">
            <CardContent className="contact-card-content">
              <p>
                <strong>First Name:</strong> {contact.firstName}
              </p>
              <p>
                <strong>Last Name:</strong> {contact.lastName}
              </p>
              <p>
                <strong>Phone:</strong> {contact.phoneNumber}
              </p>
              <p>
                <strong>Email:</strong> {contact.email}
              </p>
            </CardContent>
            <div className="card-actions">
              <Button variant="contained" size="small" onClick={() => onEditContact(contact)}>
                Edit
              </Button>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={() => removeContact(index)}
              >
                REMOVE
              </Button>
            </div>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default ContactGrid;
